import { NgModule } from '@angular/core';
import { CheckboxComponent } from './checkbox.component';

@NgModule({
  declarations: [CheckboxComponent],
  imports: [
  ],
  exports: [CheckboxComponent]
})
export class UiCheckboxModule { }
